module.exports = __webpack_public_path__ + "static/media/indifferent.0c217939.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/indifferent.svg
// module id = 486
// module chunks = 0